import { useState } from "react";
import { Box, Stack, Switch, useTheme } from "@mui/material";
import Text from "../../../_components/Text";
import CustomPaper from "../../../_components/CustomPaper";

const InsuranceSwitch = () => {
  const theme = useTheme();

  const [enabled, setEnabled] = useState<boolean>(false);

  return (
    <CustomPaper color={theme.myTheme.colors.gray500}>
      <Stack
        direction="row"
        alignItems={"center"}
        sx={{ width: "100%" }}
        justifyContent={"space-between"}
      >
        <Text variant="regular-semi">
          Enable insurance to protect your bot
        </Text>
        <Switch sx={{
        
        }} checked={enabled} onChange={() => setEnabled(!enabled)} />
      </Stack>
      <Box paddingTop={2}>
        <Text variant="s" color={theme.myTheme.colors.foreground50}>
          Out-of-Range Insurance through an option minimizes losses if the asset moves out of range.
        </Text>
      </Box>
    </CustomPaper>
  );
};

export default InsuranceSwitch;
